import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { useIdleTimer } from "react-idle-timer";
import { getItem } from "../services/localStorageService";
import { apiEndPoints } from "../apis/index";
import api from "../apis/api";
import apiBaseUrl from "../hooks/getApiBaseUrl";
import jwt_decode from "jwt-decode";
// import { logout } from "app/utils/logout";
// import timeoutValue from "../hooks/getIdleTimeOut";

const AuthGuard = function (props) {
  const { user } = useSelector((state) => state);

  const pathname = window.location.pathname;

  const userData = getItem("auth-user");

  let authenticated = false;

  if (userData) {
    authenticated = !!userData.idToken;
  }

  const getRedirectUrl = () =>
    getItem("cognitoClientId") ? "/session/signin?user=gehc" : "/session/signin";

  const forceLogout = () => {
    localStorage.clear();
    window.location.href = getRedirectUrl();
  };

  useEffect(() => {
    if (!authenticated || process.env.NODE_ENV === "development") return;

    const intervalId = setInterval(() => {
      const currentUserData = getItem("auth-user");
      if (!currentUserData?.idToken) {
        clearInterval(intervalId);
        forceLogout();
        return;
      }
      try {
        const { exp } = jwt_decode(currentUserData.idToken);
        if (Date.now() >= exp * 1000) {
          clearInterval(intervalId);
          forceLogout();
        }
      } catch {
        clearInterval(intervalId);
        forceLogout();
      }
    }, 60 * 1000);

    return () => clearInterval(intervalId);
  }, [authenticated]);

  const handleOnIdle = authenticated
    ? async () => {
        if (process.env.NODE_ENV === "development") {
          return;
        }

        if (pathname !== "/connectPage") {
          forceLogout();
          return;
        } else {
          if (!user.sessionKey) {
            forceLogout();
            return;
          }

          try {
            const status = await api({
              url: `${apiEndPoints.getScanConnectionStatus}${user.sessionKey}`,
              baseUrl: apiBaseUrl.baseURL,
              method: "GET",
            });
            if (status?.data?.data?.status === "Validation Pending") {
              forceLogout();
              return;
            }
          } catch (e) {
            console.error(e, "error in auth guard");
          }
        }
      }
    : void 0;

  useIdleTimer({
    timeout: 1000 * 60 * 15,
    onIdle: handleOnIdle,
  });

  return <>{props.children}</>;
};

export default AuthGuard;
